export default __webpack_public_path__ + "static/media/plain-sticker-gl.3108f050.png";